import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Mobile18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path d='M11 4.75H7V3.25H11V4.75Z' fill='currentColor' />
    <path
      d='M10 14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14C8 13.4477 8.44772 13 9 13C9.55228 13 10 13.4477 10 14Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.25 1.5C3.25 0.809644 3.80964 0.25 4.5 0.25H13.5C14.1904 0.25 14.75 0.809644 14.75 1.5V16.5C14.75 17.1904 14.1904 17.75 13.5 17.75H4.5C3.80964 17.75 3.25 17.1904 3.25 16.5V1.5ZM4.75 1.75V16.25H13.25V1.75H4.75Z'
      fill='currentColor'
    />
  </Svg>
);

Mobile18.displayName = 'Mobile18';
export default Mobile18;
